import { createSlice } from "@reduxjs/toolkit";

const getInitialState = () => {
  const authData = localStorage.getItem("auth");
  if (authData) {
    try {
      const { user, token } = JSON.parse(authData);
      return { user, token, isLoading: false, error: null };
    } catch {
      localStorage.removeItem("auth");
    }
  }
  return { user: null, token: null, isLoading: false, error: null };
};

const authSlice = createSlice({
  name: "auth",
  initialState: getInitialState(),
  reducers: {
    setAuthData: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.error = null;
      localStorage.setItem("auth", JSON.stringify(action.payload));
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearAuth: (state) => {
      state.user = null;
      state.token = null;
      localStorage.removeItem("auth");
    },
  },
});

export const { setAuthData, setLoading, setError, clearAuth } =
  authSlice.actions;
export default authSlice.reducer;
